import { CDL_APP_ID, FAWKES_APP_ID } from '../../framework/constants'
import { stateRef } from '../../framework/store'
import { __info } from '../../init/debug'
import { generateAuthInfoForTsg } from './handleLogin'
import type { AuthInfo, AuthState, Credentials, GetTokenManager, LoggedInUser, UserState } from '../../framework/stateTypes'

type AuthData = {
  credentials: any
  entitlements: any
  userData: any
  accountInfo: any
} | null

export const getToken = (): string | undefined => undefined

let authData: AuthData | null = null
export const getAuthData = (authStateOrTenant: any, authInfo?: AuthInfo, loggedInUser?: LoggedInUser) => {
  // If authData exist, use it
  if (authData) {
    return authData
  }

  const isAuthState = (state: any): boolean => Boolean(state?.tsg_id && state.instances && state.user)
  const authState: AuthState = isAuthState(authStateOrTenant) ? authStateOrTenant :
    isAuthState(authInfo) ? authInfo : stateRef.current.auth
  if (authState) {
    if (!authInfo || (isAuthState(authInfo) && !authInfo.entitlements)) {
      const { tsg_id, instances, user } = authState as AuthState
      const {
        supportAccountIds = loggedInUser?.supportAccountIds || [],
        notonorafter = loggedInUser?.notonorafter || ''
      } = user as UserState
      const sessionData = {
        supportAccountIds,
        notonorafter,
      }
      authInfo = generateAuthInfoForTsg({ tsg_id: tsg_id!, instances }, sessionData)
    }
  }
  if (!authInfo) {
    if (authState?.instances?.length && !authState.instances.isFawkesRunning) {
      __info('getAuthData skipped due to no running fawkes instance')
    }
    else {
      console.error('getAuthData called when authInfo or authState is not available')
    }
    return authData
  }
  const getCspId = () => {
    if (authState?.instances) {
      const { instances } = authState as AuthState
      const inst = instances?.get(FAWKES_APP_ID) ||
        instances?.get(CDL_APP_ID) || instances?.find(inst => inst.support_account_id)
      return inst?.support_account_id || 0
    }
    return 0
  }

  const { currentSupportAccountId, email, profile, supportAccountIds } = loggedInUser || authState?.user || {}
  const { firstname, lastname, displayName, supportaccountids } = profile || {}
  const accounts = supportAccountIds?.length ? supportAccountIds : (supportaccountids && JSON.parse(supportaccountids)) || []
  const accountId = +(currentSupportAccountId || getCspId())

  // accountInfo
  const accountInfo = {
    index: 0,
    accountId,
    accountName: 'Palo Alto Networks',
  }
  for (let i = 0; i < accounts.length; i++) {
    const item = accounts[i]
    if (item.accountid === accountId) {
      accountInfo.index = i
      accountInfo.accountName = item.name
      break
    }
  }

  const companyName = accountInfo.accountName
  const userName = `${firstname} ${lastname}`.trim() || email
  // userData
  const userData = {
    userName,
    companyName,
    email,
    displayName,
    firstName: firstname,
    lastName: lastname,
  }

  // authData
  authData = {
    credentials: authInfo.credentials as Credentials,
    entitlements: authInfo.entitlements,
    userData,
    accountInfo,
  }
  return authData
}

export const getTokenManager: GetTokenManager = (_tenant, _authInfo, _loggedInUser, _featuresInfo = []) => undefined

export const getReportuuids = () => ({})

export const extractConfigComposed = (_tenant: any, _authInfo: AuthInfo, _loggedInUser: LoggedInUser) => ({})

export const extractAuthDataComposed = (_tenant: any, _authInfo: AuthInfo, _loggedInUser: LoggedInUser) => ({})
